import styled from 'styled-components';

export const SCDatePickerWrapper = styled.div`
    width: 100%;

    .MuiFormControl-root {
        width: 100%;
    }

    .MuiInputBase-root {
        width: 100%;
    }
`;
